import React from 'react'
import { FaCamera } from 'react-icons/fa'

interface DonorPhotomatchBadgeProps {
  isEligible: boolean
}

const DonorPhotomatchBadge: React.FC<DonorPhotomatchBadgeProps> = ({ isEligible }) => {
  return (
    <div className="donor-card__photomatch-section">
      <span className="photomatch__label">Photomatching</span>
      <span className={`photomatch-badge photomatch-badge--${isEligible ? 'eligible' : 'ineligible'}`}>
        <FaCamera />
        {isEligible ? 'Apto' : 'Inapto'}
      </span>
    </div>
  )
}

export default DonorPhotomatchBadge
